export const spacesToNonBrakingSpaces = <T extends string>(str: T) =>
  str.replace(/ /g, ' ')

export default spacesToNonBrakingSpaces
